import { RadioField } from '@ovotech/element-v4';
import styled from 'styled-components';

export const StyledRadioField = styled(RadioField)`
  display: flex;
  flex-direction: row;
  gap: 6rem;
`;
